module.exports = __webpack_public_path__ + "static/media/firma.d4ca9c64.jpg";